export const SET_LANGUAGE_KEY = 'SET_LANGUAGE';

export const setLanguageKey = languageKey => {
  return {
    type: SET_LANGUAGE_KEY,
    response: languageKey
  };
};
